/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetProjectCategoriesQuery } from '../../models/get-project-categories-query';
import { GetProjectCategoriesQueryResult } from '../../models/get-project-categories-query-result';

export interface ApiProjectCategoriesGetProjectCategoriesPost$Plain$Params {
  
    /**
     * The query parameters to fetch the Project Categories.
     */
    body?: GetProjectCategoriesQuery
}

export function apiProjectCategoriesGetProjectCategoriesPost$Plain(http: HttpClient, rootUrl: string, params?: ApiProjectCategoriesGetProjectCategoriesPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectCategoriesQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectCategoriesGetProjectCategoriesPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetProjectCategoriesQueryResult>;
    })
  );
}

apiProjectCategoriesGetProjectCategoriesPost$Plain.PATH = '/api/ProjectCategories/GetProjectCategories';
